import { serializeChatTokenToComponentMarkup } from "@/features/react-editor/components/chat/utils/chatTokenSerialization";
import ReactDOMServer from "react-dom/server";
import { isChatTokenSegment, parseChatTokens } from "schemas/utils/chat";

import { MarkdownRenderer } from "../MarkdownRenderer";

/**
 * Converts markdown text to HTML, preserving chat tokens as component markup.
 */
export function markdownToHtml(markdown: string): string {
  const segments = parseChatTokens(markdown);

  let processedMarkdown = markdown;

  if (segments.length > 0) {
    processedMarkdown = "";
    for (const segment of segments) {
      if (isChatTokenSegment(segment)) {
        const componentMarkup = serializeChatTokenToComponentMarkup(
          segment.token,
        );
        processedMarkdown += componentMarkup ?? segment.content;
      } else {
        processedMarkdown += segment.content;
      }
    }
  }

  const html = ReactDOMServer.renderToStaticMarkup(
    MarkdownRenderer({ children: processedMarkdown }),
  );

  return html;
}
